export default "__VITE_ASSET__BV8XFL0E__"